import axios from 'axios';

function Logout() {
  axios.post('https://admin.bhumilakshmiawasanpvtltd.in/auth-API/api/login/logout.php')
  .then((response) => {
    sessionStorage.clear();
    window.location.href = '/';
  })
  .catch((error) => {
     console.error(error);
  });
}

export default Logout;